import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetActivityLogCompanyListParams,
  GetActivityLogCompanyListResponse,
  GetBannerCompanyListParams,
  GetBannerCompanyListResponse,
  GetCompanyListParams,
  GetCompanyListResponse,
  GetEmailTemplateCompanyListParams,
  GetEmailTemplateCompanyListResponse,
  GetExpenseCompanyListParams,
  GetExpenseCompanyListResponse,
  GetWorkingPatternCompanyListParams,
  GetWorkingPatternCompanyListResponse,
} from '../types';

export const getCompanyList = createAsyncThunk<
  GetCompanyListResponse,
  GetCompanyListParams
>(
  'company/getCompanyList',
  async (params: GetCompanyListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.company.getList, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getExpenseCompanyList = createAsyncThunk<
  GetExpenseCompanyListResponse,
  GetExpenseCompanyListParams & { id: string }
>(
  'company/getExpenseCompanyList',
  async (
    params: GetExpenseCompanyListParams & { id: string },
    { rejectWithValue },
  ) => {
    try {
      const { id, ...rest } = params;
      const response = await jwtAxios.get(endPoints.company.expense(id), {
        params: rest,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmailTemplateCompanyList = createAsyncThunk<
  GetEmailTemplateCompanyListResponse,
  GetEmailTemplateCompanyListParams & { companyId: string }
>(
  'company/getEmailTemplateCompanyList',
  async (
    params: GetEmailTemplateCompanyListParams & { companyId: string },
    { rejectWithValue },
  ) => {
    try {
      const { companyId, ...rest } = params;
      const response = await jwtAxios.get(
        `${endPoints.company.getEmailTemplate}/${companyId}`,
        {
          params: rest,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getActivityLogCompanyList = createAsyncThunk<
  GetActivityLogCompanyListResponse,
  GetActivityLogCompanyListParams & { companyId: string }
>(
  'company/getActivityLogCompanyList',
  async (
    params: GetActivityLogCompanyListParams & { companyId: string },
    { rejectWithValue },
  ) => {
    try {
      const { companyId, ...rest } = params;
      const response = await jwtAxios.get(
        `${endPoints.company.activityLog}/${companyId}`,
        {
          params: rest,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getBannerCompanyList = createAsyncThunk<
  GetBannerCompanyListResponse,
  GetBannerCompanyListParams
>(
  'company/getBannerCompanyList',
  async (params: GetBannerCompanyListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.banner.main, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getWorkingPatternCompanyList = createAsyncThunk<
  GetWorkingPatternCompanyListResponse,
  GetWorkingPatternCompanyListParams & { companyId: string }
>(
  'company/getWorkingPatternCompanyList',
  async (
    params: GetWorkingPatternCompanyListParams & { companyId: string },
    { rejectWithValue },
  ) => {
    try {
      const { companyId, ...rest } = params;
      const response = await jwtAxios.get(
        `${endPoints.company.workingPattern}/${companyId}`,
        {
          params: rest,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const companyActs = {
  getCompanyList,
  getExpenseCompanyList,
  getEmailTemplateCompanyList,
  getActivityLogCompanyList,
  getBannerCompanyList,
  getWorkingPatternCompanyList,
};
